//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB9uTjHGzZmgfdh0D4r0EQYkCYol4LTEQA",
  authDomain: "calculatbit.firebaseapp.com",
  projectId: "calculatbit",
  storageBucket: "calculatbit.firebasestorage.app",
  messagingSenderId: "210184053298",
  appId: "1:210184053298:web:ab758105283476aef3922b",
  measurementId: "G-YSJXM2DW99",
};

//* Initialize Firebase
let firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
